import './PrivacyPage.css';

const PrivacyPage = () => {
  const currentDate = new Date().toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">
            Your privacy is important to us. This policy explains how we collect, use, and protect your information.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section privacy-content">
        <div className="container">
          <div className="privacy-card">
            {/* Introduction */}
            <div className="privacy-section">
              <p>
                The terms "We" / "Us" / "Our" / "Company" individually and collectively refer to GooCampus Edu Solutions Private Limited and the terms "Visitor" and "User" refer to the users.
              </p>
              <p>
                This Privacy Policy is an electronic record in the form of an electronic contract formed under the Information Technology Act, 2000 and the rules made thereunder and the amended provisions pertaining to electronic documents / records in various statutes as amended by the Information Technology Act, 2000. This Privacy Policy does not require any physical, electronic or digital signature.
              </p>
              <p>
                This Privacy Policy is a legally binding document between you and GooCampus Edu Solutions Private Limited. The terms of this Privacy Policy will be effective upon your acceptance of the same (directly or indirectly in electronic form, by clicking on the I accept tab or by use of the website or by other means) and will govern the relationship between you and GooCampus Edu Solutions Private Limited for your use of the website 12thPlus.com.
              </p>
              <p>
                This document is published and shall be construed in accordance with the provisions of the Information Technology (reasonable security practices and procedures and sensitive personal data of information) rules, 2011 under Information Technology Act, 2000; that require publishing of the Privacy Policy for collection, use, storage and transfer of sensitive personal data or information.
              </p>
              <p>
                Please read this Privacy Policy carefully. By using the Website, you indicate that you understand, agree and consent to this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not use this Website.
              </p>
              <p>
                By providing us your Information or by making use of the facilities provided by the Website, You hereby consent to the collection, storage, processing and transfer of any or all of Your Personal Information and Non-Personal Information by us as specified under this Privacy Policy. You further agree that such collection, use, storage and transfer of Your Information shall not cause any loss or wrongful gain to you or any other person.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* User Information */}
            <div className="privacy-section">
              <h2>User Information</h2>
              <p>
                To avail certain services on our Website, users are required to provide certain information for the registration process namely:
              </p>
              <ul>
                <li>Your name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Academic information</li>
                <li>Other relevant details</li>
              </ul>
              <p>
                The Information as supplied by the users enables us to improve our sites and provide you the most user-friendly experience.
              </p>
              <p>
                All required information is service dependent and we may use the above said user information to maintain, protect, and improve its services (including advertising services) and for developing new services.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* Cookies */}
            <div className="privacy-section">
              <h2>Cookies</h2>
              <p>
                To improve the responsiveness of the sites for our users, we may use "cookies", or similar electronic tools to collect information to assign each visitor a unique, random number as a User Identification (User ID) to understand the user's individual interests using the Identified Computer.
              </p>
              <p>
                Unless you voluntarily identify yourself (through registration, for example), we will have no way of knowing who you are, even if we assign a cookie to your computer. The only personal information a cookie can contain is information you supply. A cookie cannot read data off your hard drive.
              </p>
              <p>
                Our web servers automatically collect limited information about your computer's connection to the Internet, including your IP address, when you visit our site. We use this information to deliver our web pages to you upon request, to tailor our site to the interests of our users, to measure traffic within our site and let advertisers know the geographic locations from where our visitors come.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* Links to Other Sites */}
            <div className="privacy-section">
              <h2>Links to Other Sites</h2>
              <p>
                Our policy discloses the privacy practices for our own website only. Our site provides links to other websites also that are beyond our control. We shall in no way be responsible in any way for your use of such sites.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* Information Sharing */}
            <div className="privacy-section">
              <h2>Information Sharing</h2>
              <p>
                We share the sensitive personal information to any third party without obtaining the prior consent of the user in the following limited circumstances:
              </p>
              <ul>
                <li>
                  When it is requested or required by law or by any court or governmental agency or authority to disclose, for the purpose of verification of identity, or for the prevention, detection, investigation including cyber incidents, or for prosecution and punishment of offences.
                </li>
                <li>
                  We may share such information within our group companies and officers and employees of such group companies for the purpose of processing personal information on our behalf.
                </li>
              </ul>
              <p>
                We also ensure that these recipients of such information agree to process such information based on our instructions and in compliance with this Privacy Policy and any other appropriate confidentiality and security measures.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* Information Security */}
            <div className="privacy-section">
              <h2>Information Security</h2>
              <p>
                We take appropriate security measures to protect against unauthorized access to or unauthorized alteration, disclosure or destruction of data. These include internal reviews of our data collection, storage and processing practices and security measures, including appropriate encryption and physical security measures to guard against unauthorized access to systems where we store personal data.
              </p>
              <p>
                All information gathered on our Website is securely stored within our controlled database. The database is stored on servers secured behind a firewall; access to the servers is password-protected and is strictly limited.
              </p>
              <p>
                However, as effective as our security measures are, no security system is impenetrable. We cannot guarantee the security of our database, nor can we guarantee that information you supply will not be intercepted while being transmitted to us over the Internet.
              </p>
            </div>

            <div className="privacy-divider"></div>

            {/* Grievance Redressal */}
            <div className="privacy-section">
              <h2>Grievance Redressal</h2>
              <p>
                Any complaints, abuse or concerns with regards to content and or comment or breach of these terms shall be immediately informed to the designated Grievance Officer as mentioned below via in writing or through email signed with the electronic signature:
              </p>
              <div className="grievance-card">
                <h3>Mr. Maheen Ejaz (Grievance Officer)</h3>
                <p className="company-name">GooCampus Edu Solutions Pvt Ltd.</p>
                <p>
                  # 138/6, Ground Floor, 10th Main Road,<br />
                  6th A Cross, Sadashiv Nagar,<br />
                  RMV Extension, Behind SBI Bank<br />
                  Bengaluru, Karnataka - 560080<br />
                  Landmark: Next to Chevron Orchards
                </p>
                <div className="grievance-contact">
                  <div className="contact-item">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <span>080 41743956</span>
                  </div>
                  <div className="contact-item">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <a href="mailto:info@goocampus.in">info@goocampus.in</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Last Updated */}
            <div className="privacy-footer">
              <p>Last updated: {currentDate}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
